import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const deletePoll = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.SOCIAL.DELETE_POLL, data);
};

export default deletePoll;
